import ua from './ua'
import * as helper from './helper'
import cloneDeep from 'clone-deep'
import countdown from './countdown'
import copyMessage from './copyMessage'
import debounce from './debounce'
import doPay from './pay'
import fetch from './fetch'

let _Vue

const __TRIPURX__ = {
  ...ua,
  ...helper,

  copyMessage,
  dateFormat: countdown,

  clone: cloneDeep,
  doPay,
  debounce
}

const descriptor = Object.create(null)
descriptor.get = function () {
  return __TRIPURX__
}

export default {
  install(Vue) {
    if (Vue && _Vue === Vue) return
    _Vue = Vue
    Object.defineProperty(Vue.prototype, '$t', descriptor)
    Object.defineProperty(Vue.prototype, '$http', {
      get() {
        return fetch
      }
    })
  }
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time.replace(/-/g, '/'))
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}
